














































import { Component, Vue } from 'vue-property-decorator';
import { errorLogModule } from '@/store/modules/ModuleErrorLog';

@Component({
	name: 'ErrorLog'
})
/** ErrorLog */
export default class ErrorLog extends Vue {
	/** 定义状态 */
	private dialogTableVisible: any = false;

	/** err报错log */
	public get errorLogs(): any {
		return errorLogModule.logs;
	}

	/** 清楚状态 当状态 = false 的时候 */
	private clearAll(): any {
		this.dialogTableVisible = false;
		errorLogModule.ClearErrorLog();
	}
}
